import { render, staticRenderFns } from "./S12Ui.vue?vue&type=template&id=83a3e244&scoped=true"
import script from "./S12Ui.vue?vue&type=script&lang=js"
export * from "./S12Ui.vue?vue&type=script&lang=js"
import style0 from "./S12Ui.vue?vue&type=style&index=0&id=83a3e244&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83a3e244",
  null
  
)

export default component.exports